// Module
var code = "<span class=\"br-caption-2\"> {{$ctrl.isShort ? 'SHORT_SERVICE_TYPE.' + $ctrl.serviceType : 'SERVICE_TYPE.' + $ctrl.serviceType | translate}} </span> ";
// Exports
export default code;